let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lwUFR")).then(() => parcelRequire('6pEQT'));